module.exports = ".mt-20{margin-top:20px}button{min-width:200px}\n"